import * as THREE from 'three';
import Application from '../Application';
export default class RetroOffice {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        this.setModel();
    }
    setModel() {
        this.model = this.resources.items.gltfModel.retroOfficeModel.scene;
        // Texture mapping: Object Name -> Resource Name
        const textureMapping = {
            'SM_BottomDrawer': 'tBottomDrawer',
            'SM_Cable01': 'tCable01',
            'SM_Cable02': 'tCable02',
            'SM_Cable03': 'tCable03',
            'SM_Desk': 'tDesk',
            'SM_KeyBoard': 'tKeyboard',
            'SM_Monitor': 'tMonitor',
            'SM_Mouse': 'tMouse',
            'SM_PCCase': 'tPCCase',
            'PC_004004': 'tPCCase',
            'PC_004004_1': 'tPCCase',
            'SM_PCFrontCase': 'tPCFrontCase',
            'SM_Room': 'tRoom',
            'SM_TopDrawer': 'tTopDrawer',
        };
        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                const textureName = textureMapping[child.name];
                if (textureName) {
                    const texture = this.resources.items.texture[textureName];
                    texture.flipY = false;
                    texture.encoding = THREE.sRGBEncoding;
                    const material = new THREE.MeshBasicMaterial({
                        map: texture,
                    });
                    child.material = material;
                }
            }
        });
        // Position adjustment - keeping the Z offset from previous models as a starting point
        this.model.position.z -= 6965;
        this.model.position.y = 55;
        this.model.position.x = 45;
        this.model.scale.set(875, 875, 875);
        this.scene.add(this.model);
    }
}
